import s from './StatsBar.module.scss';

function StatCard({ label, value, sub, accent }) {
    return (
        <div className={`${s.card} ${accent ? s[accent] : ''}`}>
            <div className={s.value}>{value ?? '—'}</div>
            <div className={s.label}>{label}</div>
            {sub && <div className={s.sub}>{sub}</div>}
        </div>
    );
}

export default function StatsBar({ stats }) {
    if (!stats) {
        return (
            <div className={s.bar}>
                {[...Array(5)].map((_, i) => <div key={i} className={`${s.card} ${s.skeleton}`} />)}
            </div>
        );
    }

    return (
        <div className={s.bar}>
            <StatCard label="Установлено" value={stats.installed_portals} sub={`за всё время ${stats.total_portals}`} />
            <StatCard label="Платные подписки" value={stats.paying_portals} accent="blue" />
            <StatCard label="Триал подписки" value={stats.trial_portals} accent="amber" />
            <StatCard label="AI-запросов за 30 дней" value={stats.total_ai_calls_last_month.toLocaleString('ru-RU')} accent="purple" />
            <StatCard label="Активных токенов расширения" value={stats.active_extension_tokens} sub={`за всё время ${stats.total_extension_tokens}`} accent="green" />
        </div>
    );
}
